var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PureComponent } from 'react';
import Image from '../Image';
import Input from '../../components/Input';
import PropTypes from 'prop-types';

var Uploader = function (_PureComponent) {
  _inherits(Uploader, _PureComponent);

  function Uploader(props) {
    _classCallCheck(this, Uploader);

    var _this = _possibleConstructorReturn(this, (Uploader.__proto__ || Object.getPrototypeOf(Uploader)).call(this, props));

    _this._handleUploadPhoto = function (e) {
      var onChange = _this.props.onChange;


      if (e.target.files && e.target.files[0]) {
        var reader = new FileReader();
        var files = e.target.files;


        reader.onload = function (e) {
          var result = e.target.result;


          _this.setState({
            avatar: result
          }, onChange && onChange(files[0]));
        };

        reader.readAsDataURL(files[0]);
      }
    };

    _this.state = {
      avatar: null
    };
    return _this;
  }

  _createClass(Uploader, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          id = _props.id,
          title = _props.title,
          className = _props.className,
          description = _props.description,
          defaultURL = _props.defaultURL,
          noImagePlaceholder = _props.noImagePlaceholder,
          error = _props.error;
      var avatar = this.state.avatar;


      return React.createElement(
        'div',
        { className: 'uploader-wrapper ' + (className || '') },
        React.createElement(
          'div',
          { className: 'label' },
          title
        ),
        description && React.createElement(
          'div',
          { className: 'description' },
          description
        ),
        React.createElement(
          'div',
          { className: 'logo-placeholder' },
          avatar || defaultURL ? React.createElement(Image, { src: avatar || defaultURL, className: 'uploader-logo' }) : React.createElement(
            'div',
            { className: 'logo-placeholder-text' },
            noImagePlaceholder
          ),
          React.createElement(Input, {
            ref: function ref(node) {
              _this2.uploadInput = node;
            },
            className: 'logo-input',
            id: id,
            type: 'file',
            onChange: this._handleUploadPhoto
          }),
          React.createElement('label', { className: 'upload-button', htmlFor: id }),
          (avatar || defaultURL) && React.createElement('div', { className: 'refresh-icon' })
        ),
        React.createElement(
          'span',
          { className: 'error-message' },
          error
        )
      );
    }
  }]);

  return Uploader;
}(PureComponent);

Uploader.propTypes = {
  /** ID of the uploader */
  id: PropTypes.string,
  /** Title to show above the uploader */
  title: PropTypes.string,
  /** Classnames that the wrapper will use */
  className: PropTypes.string,
  /** Description to go under the title */
  description: PropTypes.string,
  /** Default URL for the image src */
  defaultURL: PropTypes.string,
  /** If no avatar or default URL is present this will be shown instead */
  noImagePlaceholder: PropTypes.any,
  /** Errors to display */
  error: PropTypes.string
};

Uploader.defaultProps = {
  id: 'filesToUpload',
  title: '',
  className: '',
  description: '',
  defaultURL: '',
  noImagePlaceholder: null,
  error: ''
};

export default Uploader;